<template>
  <div class="wg-col wg-xs-12" style="padding: 2%">
    <wg-modal
      v-if="openModal"
      :width="windowWidth > 700 ? '500px' : '80%'"
      :portal="true"
      @closeModal="closeModal"
    >
      <div slot="header" class="com-anm22-app-text-xl">
        <span>{{
          mode == "edit"
            ? $anm22.strLang(lang, "Edit", "Modifica " + currentCardType.name)
            : $anm22.strLang(lang, "New", "Nuovo")
        }}</span>
      </div>

      <div slot="body">
        <span>{{ $anm22.strLang(lang, "Name", "Nome") }}</span>
        <div class="wg-col">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="currentCardType.name"
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{ $anm22.strLang(lang, "Image URL", "URL immagine") }}</span>
        <div class="wg-col">
          <input
            class="input-elem print-elem com-anm22-app-input-text"
            type="text"
            v-model="currentCardType.cardImage"
          />
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{
          $anm22.strLang(lang, "Permanent pass", "Pass permanent")
        }}</span>
        <div class="wg-col">
          <select
            class="input-elem print-elem com-anm22-app-select"
            v-model="currentCardType.isPermanent"
          >
            <option :value="0">
              {{ $anm22.strLang(lang, "No", "No") }}
            </option>
            <option :value="1">
              {{ $anm22.strLang(lang, "Yes", "Si") }}
            </option>
          </select>
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span>{{ $anm22.strLang(lang, "Pass entity", "Entità pass") }}</span>
        <div class="wg-col">
          <select
            class="input-elem print-elem com-anm22-app-select"
            v-model="cardCategory"
          >
            <option value="person">
              {{ $anm22.strLang(lang, "Person", "Persona") }}
            </option>
            <option value="vehicle">
              {{ $anm22.strLang(lang, "Vehicle", "Veicolo") }}
            </option>
            <option value="hospitality">
              {{ $anm22.strLang(lang, "Hospitality", "Hospitality") }}
            </option>
          </select>
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <span v-if="cardCategory === 'person'">{{
          $anm22.strLang(lang, "FMI Member required", "Tessera FMI richiesta")
        }}</span>
        <div v-if="cardCategory === 'person'" class="wg-col">
          <select
            class="input-elem print-elem com-anm22-app-select"
            v-model="currentCardType.requiredFmiMember"
          >
            <option :value="0">
              {{ $anm22.strLang(lang, "No", "No") }}
            </option>
            <option :value="1">
              {{ $anm22.strLang(lang, "Yes", "Si") }}
            </option>
          </select>
          <div class="vertical-height-div" style="height: 12px"></div>
        </div>
        <div class="vertical-height-div" style="height: 20px"></div>
        <div class="wg-row">
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Save', 'Salva')"
            @click="saveTicketType"
          />
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Delete', 'Elimina')"
            class="red"
            style="margin-left: 10px"
            @click="removeCardType(currentCardType)"
          />
        </div>
      </div>
    </wg-modal>
    <div style="font-size: 24px" class="com-anm22-app-text-m">
      {{ $anm22.strLang(lang, "Ticket types", "Tipologie biglietti") }}
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>
    <div class="wg-row tickets-list-menu">
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Add type', 'Aggiungi tipologia')"
        @click="add"
      />
      <WGPageControls
        :offset="pageOffset"
        :limit="pageResultsNum"
        :itemsNum="ticketTypes.length"
        :language="lang"
        :prevPageClick="prevPage"
        :nextPageClick="nextPage"
        :firstPageClick="firstPage"
        :lastPageClick="lastPage"
      ></WGPageControls>
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>
    <div class="tickets-list">
      <div class="wg-row ticket-row header">
        <div class="name">{{ $anm22.strLang(lang, "Name", "Nome") }}</div>
        <div class="edit"></div>
      </div>
      <div
        class="wg-row ticket-row"
        v-for="(ticketType, index) in ticketTypesList
          .filter((t) => !t.deleted)
          .slice(pageOffset, pageOffset + pageResultsNum)"
        :key="index"
        @click="$router.push('/tickets/types/' + ticketType.idWorldCardType)"
      >
        <div class="name">
          <img
            v-if="!ticketType.isVehicle && !ticketType.isFood"
            :src="$anm22.icons.getWorldIcon('person')"
            class="ticket-type-ic"
            :title="$anm22.strLang(lang, 'Person', 'Persona')"
          />
          <img
            v-if="ticketType.isVehicle"
            :src="$anm22.icons.getWorldIcon('van')"
            class="ticket-type-ic"
            :title="$anm22.strLang(lang, 'Vehicle', 'Veicolo')"
          />
          <img
            v-if="ticketType.isFood"
            :src="$anm22.icons.getWorldIcon('pickUpRestaurant')"
            class="ticket-type-ic"
            :title="$anm22.strLang(lang, 'Hospitality', 'Hospitality')"
          />
          <img
            v-if="ticketType.isPermanent"
            :src="$anm22.icons.getWorldIcon('public')"
            class="ticket-type-ic"
            :title="$anm22.strLang(lang, 'Permanent', 'Permanente')"
          />
          {{ ticketType.name }}
        </div>
        <div class="edit">
          <img
            :src="$anm22.icons.getWorldIcon('edit')"
            class="edit-btn"
            :title="$anm22.strLang(lang, 'Edit', 'Modifica')"
            @click="
              $router.push('/tickets/types/' + ticketType.idWorldCardType)
            "
          />
        </div>
      </div>
      <div
        class="empty-list-msg"
        v-if="!ticketTypes || ticketTypes.length == 0"
      >
        {{
          $anm22.strLang(
            lang,
            "No ticket type.",
            "Nessuna tipologia biglietto."
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WGPageControls from "../../../../world/spa/components/WGPageControls.vue";

export default {
  components: {
    WGPageControls,
  },
  data() {
    return {
      ticketTypes: [],
      mode: "edit",
      openModal: false,
      currentCardType: {},
      pageResultsNum: 50,
      pageOffset: 0,
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
    }),
    cardCategory: {
      get() {
        if (this.currentCardType.isFood) return "hospitality";
        if (this.currentCardType.isVehicle) return "vehicle";
        return "person";
      },
      set(value) {
        if (value === "hospitality") {
          this.currentCardType.isVehicle = 0;
          this.currentCardType.isFood = 1;
        } else if (value === "vehicle") {
          this.currentCardType.isVehicle = 1;
          this.currentCardType.isFood = 0;
        } else {
          this.currentCardType.isVehicle = 0;
          this.currentCardType.isFood = 0;
        }
      },
    },
    ticketTypesList() {
      return this.ticketTypes
        .filter((t) => !t.deleted)
        .sort((a, b) => {
          if (a.isPermanent < b.isPermanent) return 1;
          if (a.isPermanent > b.isPermanent) return -1;
          if (a.isVehicle < b.isVehicle) return -1;
          if (a.isVehicle > b.isVehicle) return 1;
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
    },
  },
  methods: {
    searchFn(string) {
      const regexp = new RegExp(string, "i");
      let results = [];
      /* Ricerca contatti per nome */
      results = results.concat(
        this.ticketTypes
          .filter((p) => {
            return -1 !== p.name.search(regexp);
          })
          .map((p) => {
            const label = p.name || "";
            return {
              label: label,
              img: this.$anm22.icons.getWorldIcon("package"),
              submitFn: () => {
                this.$router.push('/tickets/types/' + p.idWorldCardType)
              },
            };
          })
      );
      return results;
    },
    loadData() {
      this.$http
        .get("tickets/types")
        .then((response) => {
          this.ticketTypes = response.data.cardTypes;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    add() {
      this.currentCardType = {};
      this.openModal = true;
      this.mode = "new";
    },
    saveTicketType() {
      if (this.mode == "new") {
        this.$http
          .post(
            "tickets/types",
            {
              cardType: this.currentCardType,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.$anm22.eventBus.$emit("wg-modal-close");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$http
          .post(
            "tickets/types/" + this.currentCardType.idWorldCardType,
            {
              cardType: this.currentCardType,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.loadData();
            this.$anm22.eventBus.$emit("wg-modal-close");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    selectCardType(cardType) {
      this.mode = "edit";
      this.openModal = true;
      this.currentCardType = cardType;
    },
    closeModal() {
      this.loadData();
      this.openModal = false;
    },
    nextPage() {
      if (this.pageOffset + this.pageResultsNum < this.ticketTypes.length) {
        this.pageOffset += this.pageResultsNum;
      }
    },
    prevPage() {
      if (this.pageOffset > 0) {
        this.pageOffset -= this.pageResultsNum;
      }
    },
    firstPage() {
      this.pageOffset = 0;
    },
    lastPage() {
      if (this.ticketTypes.length <= 0) {
        this.pageOffset = 0;
      } else {
        this.pageOffset =
          Math.floor((this.ticketTypes.length - 1) / this.pageResultsNum) *
          this.pageResultsNum;
      }
    },
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.$anm22.eventBus.$emit("world-headbar-search-config", {
      hintFn: this.searchFn,
    });
  },
};
</script>

<style lang="scss" scoped>
.tickets-list {
  overflow-x: auto;

  .ticket-row {
    border-radius: 8px;
    min-height: 49px;
    padding: 5px;
    flex-wrap: nowrap;
    cursor: pointer;
    max-width: 1700px;

    .ticket-type-ic {
      display: inline-flex;
      text-align: center;
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }

    &:hover {
      background-color: #f9f9f9;
    }
    div {
      display: inline-block;
      vertical-align: top;
      white-space: normal;
      padding: 11px;

      &.code {
        flex: 1;
        width: 10%;
        min-width: 60px;
        word-wrap: break-word;
      }
      &.name {
        flex: 3;
        width: 15%;
        min-width: 120px;
      }
      &.category {
        flex: 1;
        width: 15%;
        min-width: 120px;
      }
      &.quantity {
        width: 10%;
        min-width: 60px;
      }
      &.color {
        width: 42px;

        .color-preview {
          border: 1px solid #ddd;
          border-radius: 10px;
          box-sizing: border-box;
          width: 16px;
          height: 16px;
          padding: 0;
        }
      }
      &.edit,
      &.delete {
        padding: 8px;
        width: 36px;

        .edit-btn,
        .delete-btn {
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
      }
    }

    &.header {
      div {
        font-weight: 600;
      }

      &:hover {
        background: none !important;
      }
    }
  }

  .empty-list-msg {
    padding: 16px;
  }
}

.tickets-list-menu {
  align-items: center;
  max-width: 1700px;
}
</style>
